import * as yup from 'yup';
import { RenderConfig, Row, DateRangeInput } from 'commons-ui';

import { FORM_FIELD_KEYS } from '../constants';

export const SEVEN_DAYS_IN_MS: number = 604800000;

export const validationSchema = yup.object().shape({
	dateRange: yup.array().test({
		message: 'Date Range should be less than 7 days',
		test: (value: any) => value[1] - value[0] <= SEVEN_DAYS_IN_MS
	})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DATE_RANGE]: new RenderConfig()
		.setName('dateRange')
		.setLabel('Date Range')
		.setRenderer(DateRangeInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.DATE_RANGE)];
